import React from 'react';
import DataTable from '../../collection/DataTable';
import TableHandler from '../../collection/TableHandler';
import UsuariosFilter from '../../components/filters/UsuariosFilter';
import { apiForm } from '../../utils/api';
import { generateFormData, sortableString } from '../../utils/functions';

export default function DiasVacaciones(props) {
    
    // filter
    const defaultFilter = {
        nombre: null,
        apellidos: null,
        departamentoId: null,
        localidadId: null,
        convenioId: null
    };
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("vacaciones/diasVacacionesTable", filter);
    };

    // render
    return <>
        <h2>Días de vacaciones</h2>
        <TableHandler
            onUpdate={updateData}
            elementText="los días de vacaciones">
            <UsuariosFilter
                className="my-3" fem
                defaultValue={defaultFilter}
                selectDepartamento
                selectLocalidad />
            <DiasVacacionesTable super={props.super} className="mt-3" />
        </TableHandler>
    </>;
}

function DiasVacacionesTable(props) {
    // table columns
    const columns = [
        {
            name: "Trabajador",
            selector: row => sortableString(row.NombreCompleto),
            format: row => row.NombreCompleto,
            sortable: true
        },
        {
            name: "Año",
            selector: row => row.Ano,
            format: row => row.Ano,
            sortable: true,
            right: true
        },
        {
            name: "Total",
            selector: row => {
                const d = row.DiasTrabajador;
                return `${d.total}`;
            },
            right: true
        },
        {
            name: "Restantes",
            selector: row => {
                const d = row.DiasTrabajador;
                return `${d.restantes + d.pendientes}`;
            },
            right: true
        },
        {
            name: "Acumulados",
            selector: row => {
                const d = row.DiasTrabajador;
                return `${d.acumulados}`;
            },
            right: true
        },
    ];
    const name = (row) => "Días vacaciones " + row.NombreCompleto;

    // render
    return <>
        <DataTable key={JSON.stringify(props.data)} responsive rowname={name} columns={columns} data={props.data} pagination />
    </>;
}
